import request from '@/utils/request'
import queryString from 'querystring'
// 获取标签列表
export function getTagList(data) {
    return request({
        url: `/vertical/hubs/industry/tags/first/list`,
        method: "get",
        params: data
    });
}

// 获取加速器列表
export function CoogetList(data) {
    return request({
        url: `/vertical/datas/list`,
        method: "get",
        params: data
    });
}

// 获取加速器列表
export function getHubsList(current, size, data) {
    return request({
        url: `/vertical/hubs/page/?current=${current}&size=${size}`,
        method: "post",
        data: data
    });
}

// 获取专家标签列表
export function getExpertTagList(data) {
    return request({
        url: `/vertical/experts/industry/tags/second/list`,
        method: "get",
        params: data
    });
}

// 获取专家列表
export function getExpertList(current, size, data) {
    return request({
        url: `/vertical/experts/page/?current=${current}&size=${size}`,
        method: "post",
        data: data
    });
}

// 获取背景图片
export function getVerticalImage() {
    return request({
        url: `/vertical/image/get`,
        method: "get"
    });
}

// 获取加速器详情
export function getHubsDetail(data) {
    return request({
        url: `/vertical/hubs/detail`,
        method: "get",
        params: data
    });
}
// 联系我们
export function contactUs(data) {
    return request({
        url: "/example/ask/add",
        method: "post",
        data: queryString.stringify(data)
    });
}

// 获取评价列表
export function getReviewList(data) {
    return request({
        url: `/vertical/hubs/comment/list`,
        method: "get",
        params: data
    });
}